module.exports = __webpack_public_path__ + "fonts/Beeline_Sans-Bold.1f959362.woff";